// @ts-ignore
 
import request from "src/lib/axios";

/** 分页查询商品 SPU 列表 GET /api/v1/product-spus */
export async function ProductSpuControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSpuControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductSpuDtoArray>(
    "/api/v1/product-spus",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建商品 SPU POST /api/v1/product-spus */
export async function ProductSpuControllerCreateV1(
  body: MyApi.CreateProductSpuDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductSpuDto>("/api/v1/product-spus", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询商品 SPU 详情（含 SKU） GET /api/v1/product-spus/${param0} */
export async function ProductSpuControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSpuControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductSpuDto>(
    `/api/v1/product-spus/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新商品 SPU PUT /api/v1/product-spus/${param0} */
export async function ProductSpuControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSpuControllerUpdateV1Params,
  body: MyApi.UpdateProductSpuDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductSpuDto>(
    `/api/v1/product-spus/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除商品 SPU（软删除，级联删除 SKU/分期套餐） DELETE /api/v1/product-spus/${param0} */
export async function ProductSpuControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSpuControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/product-spus/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}
